import Api from '@cabinet/services'

export default {
  createFeedback(data) {
    return Api().post(`/feedback/create/`, data)
  },
}
